import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";

import Button from "@khanacademy/wonder-blocks-button";
import {View} from "@khanacademy/wonder-blocks-core";
import {Strut} from "@khanacademy/wonder-blocks-layout";
import {OnePaneDialog} from "@khanacademy/wonder-blocks-modal";
import {Body} from "@khanacademy/wonder-blocks-typography";

export type Props = {
    handleSubmit: () => void;
    handleClose: () => void;
};

export const ConfirmDeletionModal = ({
    handleClose,
    handleSubmit,
}: Props): React.ReactElement => (
    <OnePaneDialog
        style={{maxHeight: 280}}
        role="alertdialog"
        title={t`Delete`}
        content={
            <View>
                <Body>{t`Are you sure you want to delete this?`}</Body>
            </View>
        }
        footer={
            <View style={styles.footer}>
                <Button onClick={handleClose} kind="tertiary">
                    {t`Cancel`}
                </Button>
                <Strut size={16} />
                <Button onClick={handleSubmit} color="destructive">
                    {t`Delete`}
                </Button>
            </View>
        }
    />
);

const styles = StyleSheet.create({
    footer: {
        flexDirection: "row",
    },
});

export default ConfirmDeletionModal;
